﻿import Sketch from "@arcgis/core/widgets/Sketch";
import {buildDotNetGraphic} from "./dotNetBuilder";
import Graphic from "@arcgis/core/Graphic";
import {buildJsGraphic} from "./jsBuilder";

export default class SketchWidgetWrapper {
    private sketch: Sketch;

    constructor(sketch: Sketch) {
        this.sketch = sketch;
    }

    getActiveTool() {
        return this.sketch.activeTool;
    }

    getCreateGraphic() {
        let jsGraphic = this.sketch.createGraphic;
        if (jsGraphic === undefined || jsGraphic === null) {
            return null;
        }

        return buildDotNetGraphic(jsGraphic);
    }

    getUpdateGraphics() {
        let jsGraphics = this.sketch.updateGraphics;
        if (jsGraphics === undefined || jsGraphics === null) {
            return [];
        }

        let graphics = [];
        for (let jsGraphic of jsGraphics) {
            graphics.push(buildDotNetGraphic(jsGraphic));
        }
        
        return graphics;
    }

    cancel() {
        this.sketch.cancel();
    }

    complete() {
        this.sketch.complete();
    }

    create(tool: any, options: any) {
        if (options !== null) {
            this.sketch.create(tool, options);
        } else {
            this.sketch.create(tool);
        }
    }

    delete() {
        this.sketch.delete();
    }

    duplicate() {
        this.sketch.duplicate();
    }

    redo() {
        this.sketch.redo();
    }

    undo() {
        this.sketch.undo();
    }

    update(graphics, options) {
        let jsGraphics: Graphic[];
        if (Array.isArray(graphics)) {
            jsGraphics = graphics.map((graphic) => buildJsGraphic(graphic, null));
        } else {
            jsGraphics = [buildJsGraphic(graphics, null)];
        }
        if (options !== null) {
            this.sketch.update(jsGraphics, options);
        } else {
            this.sketch.update(jsGraphics);
        }
    }
}